import AppDBStorage from '@Services/AppDBStorage';

class ResultsPreviewStorage extends AppDBStorage {
  constructor() {
    super('previewResults_');
  }

  // eslint-disable-next-line class-methods-use-this
  getDefaultValue = () => ({ previewResults: [], allResults: [] });
}

export default new ResultsPreviewStorage();
